module.exports = __webpack_public_path__ + "img/Logo-yijian.f088c490.jpg";